/**
 * AiDisclosureNotice — aviso de que el interlocutor es un sistema de IA.
 *
 * HU-037 / #497, N-1. Reglamento (UE) 2024/1689 (AI Act), arts. 50.1 y 50.5:
 * la persona debe quedar informada de que interactúa con un sistema de IA "a más
 * tardar en el momento de la primera interacción o exposición", de forma clara,
 * distinguible y conforme a los requisitos de accesibilidad aplicables.
 * Aplicable desde 2026-08-02.
 *
 * REDACCIÓN FIJADA POR LEGAL (Erin) — no editar sin su VoBo:
 * RESPUESTA-erin-melissa-497-hu037-camino-c-n1_260728_1556.md §6, y la variante
 * plural de RESPUESTA-erin-linus-497-n1-lectura-implementacion_260728_2006.md §3.
 * Estructura y ubicación fijadas por la SPEC de Werner
 * (SPEC-linus-497-hu037-n1-aviso-primer-contacto_260728_1642.md §3/§4/§5).
 *
 * La segunda oración no es adorno: desactiva el badge de rol («Especialista
 * Legal», «CTO / Head of IT»), que es la pieza que hoy informa de lo contrario.
 * Y como el badge que desmiente es PERSISTENTE, su desmentido lo es también
 * (Erin §1a): la cláusula del cargo no se recorta para ganar espacio.
 *
 * No descartable por diseño: sin botón de cierre no hay estado que persistir ni
 * riesgo de «visto una vez, nunca más».
 *
 * DIRECCIÓN DEL FALLO (condición 8 de Erin) — este componente NUNCA devuelve
 * null. Si el nombre del interlocutor no resuelve, degrada a la variante sin
 * nombre: lo que la norma exige es «un sistema de IA — no una persona», y el
 * nombre es cortesía. Fallar hacia «cero disclosure» sería exactamente el estado
 * que este ticket corrige. Mismo criterio fail-closed que el guard de telemetría:
 * por defecto el estado seguro, y aquí el estado seguro es informar.
 *
 * Variante sin `agentName` (pantalla de entrada): aún no hay interlocutor, y es
 * la exposición más cargada del producto —19 agentes con foto, nombre propio y
 * cargo humano, y un compositor desde el que se puede enviar el primer mensaje
 * sin haber visto ningún aviso—. El aviso habla del equipo (condición 9 de Erin).
 */
export default function AiDisclosureNotice({ agentName, agentRole }) {
  return (
    <div
      className="ai-disclosure"
      role="note"
      aria-label="Aviso: estás hablando con un sistema de IA"
    >
      {agentName ? (
        <p className="ai-disclosure__text">
          Estás hablando con <strong>{agentName}</strong>, un sistema de IA — no con una persona.
          {agentRole
            ? <> El cargo que aparece junto a su nombre («{agentRole}») describe la especialización de este agente, no a un profesional humano.</>
            : <> El cargo que aparece junto a su nombre describe la especialización de este agente, no a un profesional humano.</>}
        </p>
      ) : (
        <p className="ai-disclosure__text">
          Los miembros del equipo que ves aquí son <strong>sistemas de IA, no personas</strong>. Los
          cargos que acompañan a sus nombres describen su especialización, no a profesionales humanos.
        </p>
      )}
      <p className="ai-disclosure__text ai-disclosure__text--sec">
        Sus respuestas pueden contener errores y no sustituyen el criterio de un profesional.
      </p>
    </div>
  )
}
